import { StoryblokGridSection } from './StoryblokGridSection'

import { createGridSection } from './__mocks__/gridSection'

export { createGridSection }

// Re-export for backward compatibility
export const dummyGridSectionBlok = createGridSection()

export default StoryblokGridSection
